import { Link } from 'react-router-dom'
import IconBack from '../icons/IconBack'
import Logo from '../icons/logo.svg'

const TopHeaderMenu = (props) => {
  return (
    <div className="bg-gray-900 text-white sticky top-0 z-50">
      <div className="flex items-center justify-between px-4 py-4">
        {/* Botón atrás */}
        {props.onClickBack && (
          <button
            onClick={props.onClickBack}
            className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
          >
            <IconBack className="w-5 h-5" />
          </button>
        )}

        {/* Logo centrado y clicable */}
        <div className="flex-1 flex justify-center">
          <Link to="/" className="block">
            <img
              src={Logo}
              alt="Logo ChampionChipNorte Live"
              className="h-10 md:h-12 hover:opacity-90 transition-opacity"
            />
          </Link>
        </div>

        {/* Espaciador para mantener simetría con el botón atrás */}
        <div className="w-9" />
      </div>
    </div>
  )
}

export default TopHeaderMenu
